import { useAtomValue } from 'jotai';
import React from 'react';

import { ReceptionDrawerFileArea } from '~/components/layouts/ReceptionDrawer/FileArea';
import { ReceptionFileType } from '~/constants/reception_file_type';
import { outpatientQuestionnaireEntryFileAreaState } from '~/state/reception_drawer/atoms';

import { Questionnaire } from './Questionnaire';

type Props = {
  onClose: () => void;
};

export const FileArea = (props: Props) => {
  const { type } = useAtomValue(outpatientQuestionnaireEntryFileAreaState);

  return (
    <ReceptionDrawerFileArea onClose={props.onClose}>
      {type === ReceptionFileType.questionnaire && <Questionnaire />}
    </ReceptionDrawerFileArea>
  );
};
